export default "__VITE_ASSET__DO9DZhQv__"